<template>
  <div id="modal" class="modal modal-full" :class="{'maxed':(mode=='onboard')}" role="dialog">
    <button
			v-if="mode !== 'onboard'"
      type="button"
      :class="closeBtnClasses"
      @click="close"
      aria-label="Close modal"
      title="Close"
    >
      ×
    </button>

    <transition name="fade">
      <div v-if="message" class="modal-message">
        <h2 class="modal-message__title">Join the community</h2>
        <div class="image">
          <img :src="`/images/modal/prompt.svg?${$config.version}`" alt="Join the community" loading="lazy">
        </div>
        <p class="modal-message__text">Get matched with a job that matters to you & the world</p>
        <div class="modal-message__join">
          <button @click.prevent="doAction('join')" class="btn btn-blue-light uppercase">Sign up quickly</button>
        </div>
        <div class="modal-message__login">
          <p>Already have an account? <a href="#" @click.prevent="doAction('login')">Login</a></p>
        </div>
      </div>
    </transition>

    <block-spinner :active="isLoading" color="text-blue-light" class="absolute"></block-spinner>
    <iframe v-if="data" class="iframe-signin" :src="data.url+`&mode=${mode}&return-url=${return_url}`" :title="mode" height="600" frameborder="0" allowfullscreen @load="iframeLoaded" :key="mode"></iframe>

  </div>
</template>

<script>
	import AuthMixins from '@/mixins/AuthMixins';

  export default {
    name: 'SignIn',

    mixins: [AuthMixins],

		emits: ['set:persistent'],

    props: {
    	payload: {
    		type: [Object,String]
    	}
    },

    data() {
      return {
        data: false,
        isLoading: true,
        message: false,
        showIframe: false,
        mode: 'login'
      }
    },

    mounted() {

    	if (window.addEventListener) {
			  window.addEventListener("message", this.onMessage, false);
			}
			else if (window.attachEvent) {
			  window.attachEvent("onmessage", this.onMessage, false);
			}

      this.data = typeof this.payload == 'string' ? JSON.parse(this.payload) : this.payload;
      this.message = this.data.message;
      this.mode = this.data.mode;
    },

    methods: {
			captureClick() {

			},
      close() {
        this.$emit('close')
      },
      iframeLoaded() {
        this.isLoading = false;
      },
      onMessage(event) {
		    let result = event.data;
		    console.log("Message Received", event);
		    // Check sender origin to be trusted
		    if (event.origin.includes("escapethecity.org") === false) return;

				if (result.func == "setModalModeOnboard") {
		    	this.mode = 'onboard';
		    }

				if (result.func == "redirectPreferences") {
					window.onbeforeunload = null;
					window.location = this.data.preferences_url;
				}

		    if (result.func == "modalClose") {
		    	window.onbeforeunload = null;
					window.location = window.location.href;
		    }

				if (result.func == "modalRedirect") {
		    	let return_url = result.url;
					if (return_url.includes("https%3A")) {
						return_url = decodeURIComponent(return_url.replace(/\+/g,  " "));
					}
					window.onbeforeunload = null;
					window.location = return_url;
		    }
			},
      doAction(type) {
				console.log({type});
        this.mode = type
        this.message = false;
      }
    },

    computed: {
      closeBtnClasses() {
        return {
          'btn-close': true,
          'text-white': !this.message,
          'text-blue-dark': this.message
        }
      },
			return_url() {
				return window.location.href;
			}
    },
		watch: {
			mode: {
				handler() {
					this.$emit('set:persistent', (this.mode == 'onboard'))
				}
			}
		}
  };
</script>
